import { DisplayControlGroup, MenuButtonActivation, MenuDisplayRestriction } from 'features/DisplayControlGroup/models';
import axiosClient from 'utils/axiosClient';

export interface Response {
  status: string;
  message: string;
  data: DisplayControlGroup;
}

export interface ResponseRestriction {
  status: string;
  message: string;
  data: MenuDisplayRestriction[];
}

export interface ResponseActivation {
  status: string;
  message: string;
  data: MenuButtonActivation[];
}

interface ControlGroupRequest {
  display_control_group: number;
  menu_ids: number[];
}

interface DeleteRestrictionsRequest {
  ids: number[];
}

interface DeleteActivationsRequest {
  ids: number[];
}

const service = {
  async get(id: number): Promise<Response> {
    const url = `control-group-menu-detail/${id}/`;
    return await axiosClient.get(url);
  },
  async createRestriction(data: ControlGroupRequest): Promise<ResponseRestriction> {
    const url = `menu-display-restriction/`;
    return await axiosClient.post(url, data);
  },
  async createActivation(data: ControlGroupRequest): Promise<ResponseActivation> {
    const url = `menu-button-activation/`;
    return await axiosClient.post(url, data);
  },
  async deleteRestrictions(body: DeleteRestrictionsRequest): Promise<ResponseRestriction> {
    const url = `delete-restrictions/`;
    return axiosClient.delete(url, { data: body });
  },
  async deleteActivations(body: DeleteActivationsRequest): Promise<ResponseRestriction> {
    const url = `delete-activations/`;
    return axiosClient.delete(url, { data: body });
  },
};

export default service;
